import { type IntlShape } from 'react-intl-next';

import { getUserRecommendations } from '@atlaskit/smart-user-picker';

type ProductKeyType = 'confluence' | 'jira';

type GetContributorsProps = {
	query: string;
	userId: string;
	cloudId: string;
	productKey: ProductKeyType;
	maxNumberOfResults: number;
	intl: IntlShape;
};

export const getContributors: ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetContributorsProps) => Promise<import('@atlaskit/user-picker').OptionData[]> = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetContributorsProps) => {
	const requestParams = {
		context: {
			contextType: 'contributors',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
